/* eslint-disable */
// @ts-nocheck
"use client";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _ApplicationCreateAborted_error, _ApplicationCreateAborted_message, _ApplicationPushInfoAborted_error, _ApplicationPushInfoAborted_message, _ApplicationUpAborted_error, _ApplicationUpAborted_message, _ApplicationUpWorkflowAborted_error, _ApplicationUpWorkflowAborted_message, _ApplicationDownAborted_error, _ApplicationDownAborted_message, _ApplicationDownWorkflowAborted_error, _ApplicationDownWorkflowAborted_message, _ApplicationRevisionStatusAborted_error, _ApplicationRevisionStatusAborted_message, _ApplicationLogsAborted_error, _ApplicationLogsAborted_message, _ApplicationActiveRevisionsAborted_error, _ApplicationActiveRevisionsAborted_message, _ApplicationStatusAborted_error, _ApplicationStatusAborted_message, _ApplicationGetAborted_error, _ApplicationGetAborted_message, _ApplicationIsAdminAborted_error, _ApplicationIsAdminAborted_message, _ApplicationMetricsWorkflowAborted_error, _ApplicationMetricsWorkflowAborted_message, _ApplicationSetSecretsAborted_error, _ApplicationSetSecretsAborted_message, _ApplicationListSecretsAborted_error, _ApplicationListSecretsAborted_message, _ApplicationDeleteSecretsAborted_error, _ApplicationDeleteSecretsAborted_message;
import * as protobuf_es from "@bufbuild/protobuf";
import * as reboot_react from "@reboot-dev/reboot-react";
import * as reboot_web from "@reboot-dev/reboot-web";
import * as reboot_api from "@reboot-dev/reboot-api";
import React, { useEffect, useMemo, useRef, useState, } from "react";
import { v4 as uuidv4 } from "uuid";
import { useDefaultStateIds, useRefreshBearerToken } from "@reboot-dev/reboot-react/internal";
// NOTE NOTE NOTE
//
// If you are reading this comment because you are trying to debug
// the error:
//
// Module not found: Error: Can't resolve './application_pb.js'
//
// You can resolve this by passing --react-extensions to `rbt
// generate` (or better put it in your `.rbtrc` file).
//
// This is a known issue if you're using `webpack` which uses
// `ts-loader` (https://github.com/TypeStrong/ts-loader/issues/465).
import { Application as ApplicationProto, } from "./application_pb.js";
import * as application_pb from "./application_pb.js";
// Additionally re-export all messages_and_enums from the pb module.
export { Revision, ApplicationMetrics, CreateRequest, CreateResponse, PushInfoRequest, PushInfoResponse, UpRequest, UpResponse, UpWorkflowRequest, UpWorkflowResponse, DownRequest, DownResponse, DownWorkflowRequest, DownWorkflowResponse, RevisionStatusRequest, RevisionStatusResponse, LogsRequest, LogsResponse, ActiveRevisionsRequest, ActiveRevisionsResponse, StatusRequest, StatusResponse, GetRequest, GetResponse, IsAdminRequest, IsAdminResponse, SetSecretsRequest, SetSecretsResponse, ListSecretsRequest, ListSecretsResponse, DeleteSecretsRequest, DeleteSecretsResponse, InvalidInputError, ConcurrentModificationError, PaymentMethodRequiredError, BillingError, MetricsWorkflowRequest, MetricsWorkflowResponse, Status, ApplicationSize, } from "./application_pb.js";
// It is important that the following is a function, so we can lazily
// initialize the cache, so users who do not use offline cache do not
// see any logs about its initialization.
export const offlineCacheStorageType = () => reboot_web.offlineCache().offlineCacheStorageType;
reboot_api.check_bufbuild_protobuf_library(protobuf_es.Message);
const ERROR_TYPES = [
    // gRPC errors.
    reboot_api.errors_pb.Cancelled,
    reboot_api.errors_pb.Unknown,
    reboot_api.errors_pb.InvalidArgument,
    reboot_api.errors_pb.DeadlineExceeded,
    reboot_api.errors_pb.NotFound,
    reboot_api.errors_pb.AlreadyExists,
    reboot_api.errors_pb.PermissionDenied,
    reboot_api.errors_pb.ResourceExhausted,
    reboot_api.errors_pb.FailedPrecondition,
    reboot_api.errors_pb.Aborted,
    reboot_api.errors_pb.OutOfRange,
    reboot_api.errors_pb.Unimplemented,
    reboot_api.errors_pb.Internal,
    reboot_api.errors_pb.Unavailable,
    reboot_api.errors_pb.DataLoss,
    reboot_api.errors_pb.Unauthenticated,
    // Reboot errors.
    //
    // NOTE: also add any new errors into `rbt/v1alpha1/index.ts`.
    reboot_api.errors_pb.StateAlreadyConstructed,
    reboot_api.errors_pb.StateNotConstructed,
    reboot_api.errors_pb.TransactionParticipantFailedToPrepare,
    reboot_api.errors_pb.TransactionParticipantFailedToCommit,
    reboot_api.errors_pb.TransactionShouldRetry,
    reboot_api.errors_pb.UnknownService,
    reboot_api.errors_pb.UnknownTask,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationCreateRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.CreateRequest
        ? partialRequest
        : application_pb.CreateRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationCreateRequestFromJsonString = (jsonRequest) => {
    return ApplicationCreateRequestFromProtobufShape(application_pb.CreateRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationCreateRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.CreateRequest
        ? partialRequest
        : new application_pb.CreateRequest(partialRequest);
};
const ApplicationCreateResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.CreateResponse
        ? partialResponse
        : application_pb.CreateResponse.fromJson(partialResponse);
    return response;
};
const ApplicationCreateResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.CreateResponse
        ? partialResponse
        : new application_pb.CreateResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationPushInfoRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.PushInfoRequest
        ? partialRequest
        : application_pb.PushInfoRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationPushInfoRequestFromJsonString = (jsonRequest) => {
    return ApplicationPushInfoRequestFromProtobufShape(application_pb.PushInfoRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationPushInfoRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.PushInfoRequest
        ? partialRequest
        : new application_pb.PushInfoRequest(partialRequest);
};
const ApplicationPushInfoResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.PushInfoResponse
        ? partialResponse
        : application_pb.PushInfoResponse.fromJson(partialResponse);
    return response;
};
const ApplicationPushInfoResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.PushInfoResponse
        ? partialResponse
        : new application_pb.PushInfoResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationUpRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.UpRequest
        ? partialRequest
        : application_pb.UpRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationUpRequestFromJsonString = (jsonRequest) => {
    return ApplicationUpRequestFromProtobufShape(application_pb.UpRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationUpRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.UpRequest
        ? partialRequest
        : new application_pb.UpRequest(partialRequest);
};
const ApplicationUpResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.UpResponse
        ? partialResponse
        : application_pb.UpResponse.fromJson(partialResponse);
    return response;
};
const ApplicationUpResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.UpResponse
        ? partialResponse
        : new application_pb.UpResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationUpWorkflowRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.UpWorkflowRequest
        ? partialRequest
        : application_pb.UpWorkflowRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationUpWorkflowRequestFromJsonString = (jsonRequest) => {
    return ApplicationUpWorkflowRequestFromProtobufShape(application_pb.UpWorkflowRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationUpWorkflowRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.UpWorkflowRequest
        ? partialRequest
        : new application_pb.UpWorkflowRequest(partialRequest);
};
const ApplicationUpWorkflowResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.UpWorkflowResponse
        ? partialResponse
        : application_pb.UpWorkflowResponse.fromJson(partialResponse);
    return response;
};
const ApplicationUpWorkflowResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.UpWorkflowResponse
        ? partialResponse
        : new application_pb.UpWorkflowResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationDownRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.DownRequest
        ? partialRequest
        : application_pb.DownRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationDownRequestFromJsonString = (jsonRequest) => {
    return ApplicationDownRequestFromProtobufShape(application_pb.DownRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationDownRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.DownRequest
        ? partialRequest
        : new application_pb.DownRequest(partialRequest);
};
const ApplicationDownResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.DownResponse
        ? partialResponse
        : application_pb.DownResponse.fromJson(partialResponse);
    return response;
};
const ApplicationDownResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.DownResponse
        ? partialResponse
        : new application_pb.DownResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationDownWorkflowRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.DownWorkflowRequest
        ? partialRequest
        : application_pb.DownWorkflowRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationDownWorkflowRequestFromJsonString = (jsonRequest) => {
    return ApplicationDownWorkflowRequestFromProtobufShape(application_pb.DownWorkflowRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationDownWorkflowRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.DownWorkflowRequest
        ? partialRequest
        : new application_pb.DownWorkflowRequest(partialRequest);
};
const ApplicationDownWorkflowResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.DownWorkflowResponse
        ? partialResponse
        : application_pb.DownWorkflowResponse.fromJson(partialResponse);
    return response;
};
const ApplicationDownWorkflowResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.DownWorkflowResponse
        ? partialResponse
        : new application_pb.DownWorkflowResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationRevisionStatusRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.RevisionStatusRequest
        ? partialRequest
        : application_pb.RevisionStatusRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationRevisionStatusRequestFromJsonString = (jsonRequest) => {
    return ApplicationRevisionStatusRequestFromProtobufShape(application_pb.RevisionStatusRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationRevisionStatusRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.RevisionStatusRequest
        ? partialRequest
        : new application_pb.RevisionStatusRequest(partialRequest);
};
const ApplicationRevisionStatusResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.RevisionStatusResponse
        ? partialResponse
        : application_pb.RevisionStatusResponse.fromJson(partialResponse);
    return response;
};
const ApplicationRevisionStatusResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.RevisionStatusResponse
        ? partialResponse
        : new application_pb.RevisionStatusResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationLogsRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.LogsRequest
        ? partialRequest
        : application_pb.LogsRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationLogsRequestFromJsonString = (jsonRequest) => {
    return ApplicationLogsRequestFromProtobufShape(application_pb.LogsRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationLogsRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.LogsRequest
        ? partialRequest
        : new application_pb.LogsRequest(partialRequest);
};
const ApplicationLogsResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.LogsResponse
        ? partialResponse
        : application_pb.LogsResponse.fromJson(partialResponse);
    return response;
};
const ApplicationLogsResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.LogsResponse
        ? partialResponse
        : new application_pb.LogsResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationActiveRevisionsRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.ActiveRevisionsRequest
        ? partialRequest
        : application_pb.ActiveRevisionsRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationActiveRevisionsRequestFromJsonString = (jsonRequest) => {
    return ApplicationActiveRevisionsRequestFromProtobufShape(application_pb.ActiveRevisionsRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationActiveRevisionsRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.ActiveRevisionsRequest
        ? partialRequest
        : new application_pb.ActiveRevisionsRequest(partialRequest);
};
const ApplicationActiveRevisionsResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.ActiveRevisionsResponse
        ? partialResponse
        : application_pb.ActiveRevisionsResponse.fromJson(partialResponse);
    return response;
};
const ApplicationActiveRevisionsResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.ActiveRevisionsResponse
        ? partialResponse
        : new application_pb.ActiveRevisionsResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationStatusRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.StatusRequest
        ? partialRequest
        : application_pb.StatusRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationStatusRequestFromJsonString = (jsonRequest) => {
    return ApplicationStatusRequestFromProtobufShape(application_pb.StatusRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationStatusRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.StatusRequest
        ? partialRequest
        : new application_pb.StatusRequest(partialRequest);
};
const ApplicationStatusResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.StatusResponse
        ? partialResponse
        : application_pb.StatusResponse.fromJson(partialResponse);
    return response;
};
const ApplicationStatusResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.StatusResponse
        ? partialResponse
        : new application_pb.StatusResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationGetRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.GetRequest
        ? partialRequest
        : application_pb.GetRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationGetRequestFromJsonString = (jsonRequest) => {
    return ApplicationGetRequestFromProtobufShape(application_pb.GetRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationGetRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.GetRequest
        ? partialRequest
        : new application_pb.GetRequest(partialRequest);
};
const ApplicationGetResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.GetResponse
        ? partialResponse
        : application_pb.GetResponse.fromJson(partialResponse);
    return response;
};
const ApplicationGetResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.GetResponse
        ? partialResponse
        : new application_pb.GetResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationIsAdminRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.IsAdminRequest
        ? partialRequest
        : application_pb.IsAdminRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationIsAdminRequestFromJsonString = (jsonRequest) => {
    return ApplicationIsAdminRequestFromProtobufShape(application_pb.IsAdminRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationIsAdminRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.IsAdminRequest
        ? partialRequest
        : new application_pb.IsAdminRequest(partialRequest);
};
const ApplicationIsAdminResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.IsAdminResponse
        ? partialResponse
        : application_pb.IsAdminResponse.fromJson(partialResponse);
    return response;
};
const ApplicationIsAdminResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.IsAdminResponse
        ? partialResponse
        : new application_pb.IsAdminResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationMetricsWorkflowRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.MetricsWorkflowRequest
        ? partialRequest
        : application_pb.MetricsWorkflowRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationMetricsWorkflowRequestFromJsonString = (jsonRequest) => {
    return ApplicationMetricsWorkflowRequestFromProtobufShape(application_pb.MetricsWorkflowRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationMetricsWorkflowRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.MetricsWorkflowRequest
        ? partialRequest
        : new application_pb.MetricsWorkflowRequest(partialRequest);
};
const ApplicationMetricsWorkflowResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.MetricsWorkflowResponse
        ? partialResponse
        : application_pb.MetricsWorkflowResponse.fromJson(partialResponse);
    return response;
};
const ApplicationMetricsWorkflowResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.MetricsWorkflowResponse
        ? partialResponse
        : new application_pb.MetricsWorkflowResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationSetSecretsRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.SetSecretsRequest
        ? partialRequest
        : application_pb.SetSecretsRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationSetSecretsRequestFromJsonString = (jsonRequest) => {
    return ApplicationSetSecretsRequestFromProtobufShape(application_pb.SetSecretsRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationSetSecretsRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.SetSecretsRequest
        ? partialRequest
        : new application_pb.SetSecretsRequest(partialRequest);
};
const ApplicationSetSecretsResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.SetSecretsResponse
        ? partialResponse
        : application_pb.SetSecretsResponse.fromJson(partialResponse);
    return response;
};
const ApplicationSetSecretsResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.SetSecretsResponse
        ? partialResponse
        : new application_pb.SetSecretsResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationListSecretsRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.ListSecretsRequest
        ? partialRequest
        : application_pb.ListSecretsRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationListSecretsRequestFromJsonString = (jsonRequest) => {
    return ApplicationListSecretsRequestFromProtobufShape(application_pb.ListSecretsRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationListSecretsRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.ListSecretsRequest
        ? partialRequest
        : new application_pb.ListSecretsRequest(partialRequest);
};
const ApplicationListSecretsResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.ListSecretsResponse
        ? partialResponse
        : application_pb.ListSecretsResponse.fromJson(partialResponse);
    return response;
};
const ApplicationListSecretsResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.ListSecretsResponse
        ? partialResponse
        : new application_pb.ListSecretsResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const ApplicationDeleteSecretsRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof application_pb.DeleteSecretsRequest
        ? partialRequest
        : application_pb.DeleteSecretsRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const ApplicationDeleteSecretsRequestFromJsonString = (jsonRequest) => {
    return ApplicationDeleteSecretsRequestFromProtobufShape(application_pb.DeleteSecretsRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const ApplicationDeleteSecretsRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof application_pb.DeleteSecretsRequest
        ? partialRequest
        : new application_pb.DeleteSecretsRequest(partialRequest);
};
const ApplicationDeleteSecretsResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof application_pb.DeleteSecretsResponse
        ? partialResponse
        : application_pb.DeleteSecretsResponse.fromJson(partialResponse);
    return response;
};
const ApplicationDeleteSecretsResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof application_pb.DeleteSecretsResponse
        ? partialResponse
        : new application_pb.DeleteSecretsResponse(partialResponse);
};
const APPLICATION_CREATE_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    application_pb.InvalidInputError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationCreateAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_CREATE_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationCreateAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationCreateAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationCreateAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationCreateAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationCreateAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationCreateAborted_error.set(this, void 0);
        _ApplicationCreateAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationCreateAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationCreateAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationCreateAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationCreateAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationCreateAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationCreateAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationCreateAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationCreateAborted_error, "f");
    }
}
_ApplicationCreateAborted_error = new WeakMap(), _ApplicationCreateAborted_message = new WeakMap();
const APPLICATION_PUSH_INFO_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationPushInfoAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_PUSH_INFO_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationPushInfoAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationPushInfoAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationPushInfoAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationPushInfoAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationPushInfoAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationPushInfoAborted_error.set(this, void 0);
        _ApplicationPushInfoAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationPushInfoAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationPushInfoAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationPushInfoAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationPushInfoAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationPushInfoAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationPushInfoAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationPushInfoAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationPushInfoAborted_error, "f");
    }
}
_ApplicationPushInfoAborted_error = new WeakMap(), _ApplicationPushInfoAborted_message = new WeakMap();
const APPLICATION_UP_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    application_pb.InvalidInputError,
    application_pb.ConcurrentModificationError,
    application_pb.PaymentMethodRequiredError,
    application_pb.BillingError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationUpAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_UP_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationUpAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationUpAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationUpAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationUpAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationUpAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationUpAborted_error.set(this, void 0);
        _ApplicationUpAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationUpAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationUpAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationUpAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationUpAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationUpAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationUpAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationUpAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationUpAborted_error, "f");
    }
}
_ApplicationUpAborted_error = new WeakMap(), _ApplicationUpAborted_message = new WeakMap();
const APPLICATION_UP_WORKFLOW_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationUpWorkflowAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_UP_WORKFLOW_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationUpWorkflowAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationUpWorkflowAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationUpWorkflowAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationUpWorkflowAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationUpWorkflowAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationUpWorkflowAborted_error.set(this, void 0);
        _ApplicationUpWorkflowAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationUpWorkflowAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationUpWorkflowAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationUpWorkflowAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationUpWorkflowAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationUpWorkflowAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationUpWorkflowAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationUpWorkflowAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationUpWorkflowAborted_error, "f");
    }
}
_ApplicationUpWorkflowAborted_error = new WeakMap(), _ApplicationUpWorkflowAborted_message = new WeakMap();
const APPLICATION_DOWN_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    application_pb.ConcurrentModificationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationDownAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_DOWN_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationDownAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationDownAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationDownAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationDownAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationDownAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationDownAborted_error.set(this, void 0);
        _ApplicationDownAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationDownAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationDownAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationDownAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationDownAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationDownAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationDownAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationDownAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationDownAborted_error, "f");
    }
}
_ApplicationDownAborted_error = new WeakMap(), _ApplicationDownAborted_message = new WeakMap();
const APPLICATION_DOWN_WORKFLOW_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationDownWorkflowAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_DOWN_WORKFLOW_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationDownWorkflowAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationDownWorkflowAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationDownWorkflowAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationDownWorkflowAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationDownWorkflowAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationDownWorkflowAborted_error.set(this, void 0);
        _ApplicationDownWorkflowAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationDownWorkflowAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationDownWorkflowAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationDownWorkflowAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationDownWorkflowAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationDownWorkflowAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationDownWorkflowAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationDownWorkflowAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationDownWorkflowAborted_error, "f");
    }
}
_ApplicationDownWorkflowAborted_error = new WeakMap(), _ApplicationDownWorkflowAborted_message = new WeakMap();
const APPLICATION_REVISION_STATUS_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    application_pb.InvalidInputError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationRevisionStatusAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_REVISION_STATUS_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationRevisionStatusAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationRevisionStatusAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationRevisionStatusAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationRevisionStatusAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationRevisionStatusAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationRevisionStatusAborted_error.set(this, void 0);
        _ApplicationRevisionStatusAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationRevisionStatusAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationRevisionStatusAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationRevisionStatusAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationRevisionStatusAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationRevisionStatusAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationRevisionStatusAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationRevisionStatusAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationRevisionStatusAborted_error, "f");
    }
}
_ApplicationRevisionStatusAborted_error = new WeakMap(), _ApplicationRevisionStatusAborted_message = new WeakMap();
const APPLICATION_LOGS_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationLogsAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_LOGS_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationLogsAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationLogsAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationLogsAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationLogsAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationLogsAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationLogsAborted_error.set(this, void 0);
        _ApplicationLogsAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationLogsAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationLogsAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationLogsAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationLogsAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationLogsAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationLogsAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationLogsAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationLogsAborted_error, "f");
    }
}
_ApplicationLogsAborted_error = new WeakMap(), _ApplicationLogsAborted_message = new WeakMap();
const APPLICATION_ACTIVE_REVISIONS_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationActiveRevisionsAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_ACTIVE_REVISIONS_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationActiveRevisionsAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationActiveRevisionsAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationActiveRevisionsAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationActiveRevisionsAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationActiveRevisionsAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationActiveRevisionsAborted_error.set(this, void 0);
        _ApplicationActiveRevisionsAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationActiveRevisionsAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationActiveRevisionsAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationActiveRevisionsAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationActiveRevisionsAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationActiveRevisionsAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationActiveRevisionsAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationActiveRevisionsAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationActiveRevisionsAborted_error, "f");
    }
}
_ApplicationActiveRevisionsAborted_error = new WeakMap(), _ApplicationActiveRevisionsAborted_message = new WeakMap();
const APPLICATION_STATUS_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationStatusAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_STATUS_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationStatusAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationStatusAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationStatusAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationStatusAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationStatusAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationStatusAborted_error.set(this, void 0);
        _ApplicationStatusAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationStatusAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationStatusAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationStatusAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationStatusAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationStatusAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationStatusAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationStatusAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationStatusAborted_error, "f");
    }
}
_ApplicationStatusAborted_error = new WeakMap(), _ApplicationStatusAborted_message = new WeakMap();
const APPLICATION_GET_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationGetAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_GET_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationGetAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationGetAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationGetAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationGetAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationGetAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationGetAborted_error.set(this, void 0);
        _ApplicationGetAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationGetAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationGetAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationGetAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationGetAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationGetAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationGetAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationGetAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationGetAborted_error, "f");
    }
}
_ApplicationGetAborted_error = new WeakMap(), _ApplicationGetAborted_message = new WeakMap();
const APPLICATION_IS_ADMIN_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationIsAdminAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_IS_ADMIN_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationIsAdminAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationIsAdminAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationIsAdminAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationIsAdminAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationIsAdminAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationIsAdminAborted_error.set(this, void 0);
        _ApplicationIsAdminAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationIsAdminAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationIsAdminAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationIsAdminAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationIsAdminAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationIsAdminAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationIsAdminAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationIsAdminAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationIsAdminAborted_error, "f");
    }
}
_ApplicationIsAdminAborted_error = new WeakMap(), _ApplicationIsAdminAborted_message = new WeakMap();
const APPLICATION_METRICS_WORKFLOW_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationMetricsWorkflowAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_METRICS_WORKFLOW_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationMetricsWorkflowAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationMetricsWorkflowAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationMetricsWorkflowAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationMetricsWorkflowAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationMetricsWorkflowAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationMetricsWorkflowAborted_error.set(this, void 0);
        _ApplicationMetricsWorkflowAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationMetricsWorkflowAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationMetricsWorkflowAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationMetricsWorkflowAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationMetricsWorkflowAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationMetricsWorkflowAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationMetricsWorkflowAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationMetricsWorkflowAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationMetricsWorkflowAborted_error, "f");
    }
}
_ApplicationMetricsWorkflowAborted_error = new WeakMap(), _ApplicationMetricsWorkflowAborted_message = new WeakMap();
const APPLICATION_SET_SECRETS_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    application_pb.InvalidInputError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationSetSecretsAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_SET_SECRETS_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationSetSecretsAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationSetSecretsAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationSetSecretsAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationSetSecretsAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationSetSecretsAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationSetSecretsAborted_error.set(this, void 0);
        _ApplicationSetSecretsAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationSetSecretsAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationSetSecretsAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationSetSecretsAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationSetSecretsAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationSetSecretsAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationSetSecretsAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationSetSecretsAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationSetSecretsAborted_error, "f");
    }
}
_ApplicationSetSecretsAborted_error = new WeakMap(), _ApplicationSetSecretsAborted_message = new WeakMap();
const APPLICATION_LIST_SECRETS_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationListSecretsAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_LIST_SECRETS_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationListSecretsAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationListSecretsAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationListSecretsAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationListSecretsAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationListSecretsAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationListSecretsAborted_error.set(this, void 0);
        _ApplicationListSecretsAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationListSecretsAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationListSecretsAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationListSecretsAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationListSecretsAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationListSecretsAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationListSecretsAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationListSecretsAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationListSecretsAborted_error, "f");
    }
}
_ApplicationListSecretsAborted_error = new WeakMap(), _ApplicationListSecretsAborted_message = new WeakMap();
const APPLICATION_DELETE_SECRETS_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    application_pb.InvalidInputError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class ApplicationDeleteSecretsAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, APPLICATION_DELETE_SECRETS_ERROR_TYPES);
        if (error !== undefined) {
            return new ApplicationDeleteSecretsAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new ApplicationDeleteSecretsAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _ApplicationDeleteSecretsAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _ApplicationDeleteSecretsAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _ApplicationDeleteSecretsAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _ApplicationDeleteSecretsAborted_error.set(this, void 0);
        _ApplicationDeleteSecretsAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _ApplicationDeleteSecretsAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _ApplicationDeleteSecretsAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _ApplicationDeleteSecretsAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _ApplicationDeleteSecretsAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _ApplicationDeleteSecretsAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _ApplicationDeleteSecretsAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _ApplicationDeleteSecretsAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _ApplicationDeleteSecretsAborted_error, "f");
    }
}
_ApplicationDeleteSecretsAborted_error = new WeakMap(), _ApplicationDeleteSecretsAborted_message = new WeakMap();
class ApplicationInstance {
    constructor(id, stateRef, url) {
        this.observers = {};
        this.loadingReaders = 0;
        this.runningMutates = [];
        this.queuedMutates = [];
        this.flushMutates = undefined;
        this.websocket = undefined;
        this.backoff = new reboot_api.Backoff();
        this.useCreateMutations = [];
        this.useCreateSetPendings = {};
        this.usePushInfoReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.pushInfoFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.useUpMutations = [];
        this.useUpSetPendings = {};
        this.useDownMutations = [];
        this.useDownSetPendings = {};
        this.useRevisionStatusReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.revisionStatusFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.useLogsReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.logsFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.useActiveRevisionsReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.activeRevisionsFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.useStatusReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.statusFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.useGetReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.getFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.useIsAdminReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.isAdminFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.useListSecretsReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.listSecretsFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.id = id;
        this.stateRef = stateRef;
        this.url = url;
        this.refs = 1;
        // An empty `id` marks the inert instance shared by every no-id
        // caller while no default ID has resolved (e.g. signed out): it
        // opens no socket so there's nothing to connect to.
        if (id !== "") {
            reboot_web.websockets.connect(this.url, this.stateRef);
            this.initializeWebSocket();
        }
    }
    ref() {
        this.refs += 1;
        return this.refs;
    }
    unref() {
        this.refs -= 1;
        if (this.refs === 0 && this.websocket !== undefined) {
            this.websocket.close();
            reboot_web.websockets.disconnect(this.url, this.stateRef);
        }
        return this.refs;
    }
    hasRunningMutations() {
        return this.runningMutates.length > 0;
    }
    async flushMutations() {
        if (this.flushMutates === undefined) {
            this.flushMutates = new reboot_api.Event();
        }
        await this.flushMutates.wait();
    }
    readersLoadedOrFailed() {
        var _a;
        this.flushMutates = undefined;
        if (this.queuedMutates.length > 0) {
            this.runningMutates = this.queuedMutates;
            this.queuedMutates = [];
            if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                for (const { request, update } of this.runningMutates) {
                    update({ isLoading: true });
                    try {
                        this.websocket.send(request.toBinary());
                    }
                    catch (_b) {
                        // We'll retry since we've stored in `*Mutates`.
                    }
                }
            }
        }
    }
    initializeWebSocket() {
        if (this.websocket === undefined && this.refs > 0 && this.id !== "") {
            const url = new URL(`${this.url}/__/reboot/rpc/${this.stateRef}`);
            url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
            this.websocket = reboot_web.websockets.create(url);
            this.websocket.binaryType = "arraybuffer";
            this.websocket.onopen = () => {
                var _a;
                if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                    for (const { request, update } of this.runningMutates) {
                        update({ isLoading: true });
                        try {
                            this.websocket.send(request.toBinary());
                        }
                        catch (_b) {
                            // We'll retry since we've stored in `*Mutates`.
                        }
                    }
                }
            };
            this.websocket.onerror = async () => {
                if (this.websocket !== undefined) {
                    this.websocket = undefined;
                    for (const { update } of this.runningMutates) {
                        update({ isLoading: false, error: "WebSocket disconnected" });
                    }
                    if (this.refs > 0) {
                        if (this.runningMutates.length > 0) {
                            console.warn(`[Reboot] WebSocket disconnected, ${this.runningMutates.length} outstanding mutations will be retried when we reconnect`);
                        }
                        await this.backoff.wait();
                        this.initializeWebSocket();
                    }
                }
            };
            this.websocket.onclose = async () => {
                if (this.websocket !== undefined) {
                    this.websocket = undefined;
                    for (const { update } of this.runningMutates) {
                        update({ isLoading: false, error: "WebSocket disconnected" });
                    }
                    if (this.refs > 0) {
                        await this.backoff.wait();
                        this.initializeWebSocket();
                    }
                }
            };
            this.websocket.onmessage = async (event) => {
                const { resolve } = this.runningMutates[0];
                this.runningMutates.shift();
                const response = reboot_api.react_pb.MutateResponse.fromBinary(new Uint8Array(event.data));
                resolve(response);
                if (this.flushMutates !== undefined &&
                    this.runningMutates.length === 0) {
                    this.flushMutates.set();
                }
            };
        }
    }
    async mutate(partialRequest, update) {
        const request = partialRequest instanceof reboot_api.react_pb.MutateRequest
            ? partialRequest
            : new reboot_api.react_pb.MutateRequest(partialRequest);
        return new Promise((resolve, _) => {
            var _a;
            if (this.loadingReaders === 0) {
                this.runningMutates = this.runningMutates.concat({ request, resolve, update });
                if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                    update({ isLoading: true });
                    try {
                        this.websocket.send(request.toBinary());
                    }
                    catch (_b) {
                        // We'll retry since we've stored in `*Mutates`.
                    }
                }
            }
            else {
                this.queuedMutates = this.queuedMutates.concat({ request, resolve, update });
            }
        });
    }
    async read(method, serializedRequest, bearerToken, responseType, reader) {
        const queryRequest = new reboot_api.react_pb.QueryRequest({
            method,
            request: serializedRequest,
            ...(bearerToken !== undefined && { bearerToken } || {}),
        });
        let expecteds = [];
        // When we disconnect we may not be able to observe
        // responses due to mutations yet there may still be
        // some outstanding responses that are expected which
        // we treat as "orphans" in the sense that we won't
        // observe their idempotency keys but once we reconnect
        // we will still have observed their effects and can
        // call `observed()` on them.
        let orphans = [];
        const id = `${uuidv4()}`;
        this.observers[id] = {
            observe: (idempotencyKey, observed, aborted) => {
                expecteds = expecteds.concat({ idempotencyKey, observed, aborted });
            },
            unobserve: (idempotencyKey) => {
                expecteds = expecteds.filter(expected => expected.idempotencyKey !== idempotencyKey);
                orphans = orphans.filter(orphan => orphan.idempotencyKey !== idempotencyKey);
            }
        };
        try {
            await reboot_api.retryForever(async () => {
                let loaded = false;
                this.loadingReaders += 1;
                // Any mutations started after we've incremented
                // `this.loadingReaders` will be queued until after
                // all the readers have loaded and thus (1) we know all
                // current `expected` are actually `orphans` that
                // we will haved "observed" once we are (re)connected
                // because we flush mutations before starting to read
                // and (2) all queued mutations can stay in `expected`
                // because we will in fact be able to observe them
                // since they won't get sent over the websocket
                // until after we are (re)connected.
                //
                // NOTE: we need to concatenate with `orphans`
                // because we may try to (re)connect multiple times
                // and between each try more mutations may have been
                // made (or queued ones will be moved to running).
                orphans = [...orphans, ...expecteds];
                expecteds = [];
                try {
                    // Wait for potentially completed mutations to flush
                    // before starting to read so that we read the latest
                    // state including those mutations.
                    if (this.hasRunningMutations()) {
                        await this.flushMutations();
                    }
                    reader.setIsLoading(true);
                    const queryResponses = reboot_web.reactiveReader({
                        endpoint: `${this.url}/__/reboot/rpc/${this.stateRef}`,
                        request: queryRequest,
                        signal: reader.abortController.signal,
                    });
                    for await (const queryResponse of queryResponses) {
                        if (!loaded) {
                            if ((this.loadingReaders -= 1) === 0) {
                                this.readersLoadedOrFailed();
                            }
                            loaded = true;
                        }
                        reader.setIsLoading(false);
                        const response = queryResponse.responseOrStatus.case === "response"
                            ? responseType.fromBinary(queryResponse.responseOrStatus.value)
                            : undefined;
                        // If we were disconnected it must be that we've
                        // observed all `orphans` because we waited
                        // for any mutations to flush before we re-started to
                        // read.
                        const haveOrphans = orphans.length;
                        if (haveOrphans > 0) {
                            // We mark all mutations as observed except the
                            // last one which we also invoke all `setResponse`s.
                            // In this way we effectively create a barrier
                            // for all readers that will synchronize on the last
                            // mutation, but note that this still may lead
                            // to some partial state/response updates because
                            // one reader may have actually received a response
                            // while another reader got disconnected. While this
                            // is likely very rare, it is possible. Mitigating
                            // this issue is non-trivial and for now we have
                            // no plans to address it.
                            for (let i = 0; i < orphans.length - 1; i++) {
                                orphans[i].observed(() => { });
                            }
                            await orphans[orphans.length - 1].observed(() => {
                                if (response !== undefined) {
                                    reader.setResponse(response);
                                }
                            });
                            orphans = [];
                        }
                        // We want to check the orphans list AND the expecteds list because
                        // it could be possible that we receive a query response that
                        // contains an idempotency key that we are expecting while having an
                        // orphans list with a length greater than 0. In this case, we don't
                        // want to skip checking the expecteds list just because we have
                        // already checked the orphans list.
                        if (expecteds.length > 0 &&
                            queryResponse.idempotencyKeys.includes(expecteds[0].idempotencyKey)) {
                            await expecteds[0].observed(() => {
                                if (response !== undefined) {
                                    reader.setResponse(response);
                                }
                                expecteds.shift();
                            });
                        }
                        // If we don't have any orphans to observe and we don't have any expecteds to observe,
                        // or at least, the first expecteds _is not observed_ by this response, then go ahead and
                        // pass on the response because it might contain new data that should get shown to the
                        // user (e.g., in a chat room this could be a new message from a different user).
                        else if (response !== undefined && !haveOrphans) {
                            reader.setResponse(response);
                        }
                    }
                    throw new Error('Not expecting stream to ever be done');
                }
                catch (e) {
                    if (!loaded) {
                        if ((this.loadingReaders -= 1) === 0) {
                            this.readersLoadedOrFailed();
                        }
                    }
                    loaded = false;
                    if (reader.abortController.signal.aborted) {
                        for (const { aborted } of [...orphans, ...expecteds]) {
                            aborted();
                        }
                        return;
                    }
                    // Intentionally leave `isLoading: true` here. The outer
                    // `retryForever(...)` will run another attempt and call
                    // `reader.setIsLoading(true)` again at the top of the
                    // try block, but if we cleared it to `false` here first
                    // consumers would observe a brief `false → true → false
                    // → true ...` flip-flop on every retry while we're
                    // actually still trying to (re)connect. Once a response
                    // finally arrives the success path sets it to `false`.
                    if (e instanceof reboot_api.Status) {
                        reader.setStatus(e);
                    }
                    else {
                        console.warn(`[Reboot] Caught unknown exception: ${e instanceof Error ? e.message : JSON.stringify(e)}`);
                    }
                    throw e; // This just retries!
                }
            });
        }
        finally {
            delete this.observers[id];
        }
    }
    async create(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useCreateMutations = this.useCreateMutations.concat(mutation);
        for (const setPending of Object.values(this.useCreateSetPendings)) {
            setPending(this.useCreateMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "Create",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useCreateMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useCreateSetPendings)) {
                        setPending(this.useCreateMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useCreateMutations =
                    this.useCreateMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useCreateSetPendings)) {
                    setPending(this.useCreateMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: ApplicationCreateResponseFromProtobufShape(application_pb.CreateResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = ApplicationCreateAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Application.Create' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useCreate(id, setPending) {
        this.useCreateSetPendings[id] = setPending;
    }
    unuseCreate(id) {
        delete this.useCreateSetPendings[id];
    }
    startPushInfo(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.usePushInfoReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Application.PushInfo' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.pushInfoFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.usePushInfoReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `usePushInfo(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `usePushInfo(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.usePushInfoReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("PushInfo", serializedRequest, bearerToken, application_pb.PushInfoResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(application_pb.PushInfoResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Application.PushInfo' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    usePushInfo(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startPushInfo(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unusePushInfo(id, requestBearerTokenHash) {
        const reader = this.usePushInfoReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.usePushInfoReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    async up(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useUpMutations = this.useUpMutations.concat(mutation);
        for (const setPending of Object.values(this.useUpSetPendings)) {
            setPending(this.useUpMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "Up",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useUpMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useUpSetPendings)) {
                        setPending(this.useUpMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useUpMutations =
                    this.useUpMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useUpSetPendings)) {
                    setPending(this.useUpMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: ApplicationUpResponseFromProtobufShape(application_pb.UpResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = ApplicationUpAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Application.Up' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useUp(id, setPending) {
        this.useUpSetPendings[id] = setPending;
    }
    unuseUp(id) {
        delete this.useUpSetPendings[id];
    }
    async down(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useDownMutations = this.useDownMutations.concat(mutation);
        for (const setPending of Object.values(this.useDownSetPendings)) {
            setPending(this.useDownMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "Down",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useDownMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useDownSetPendings)) {
                        setPending(this.useDownMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useDownMutations =
                    this.useDownMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useDownSetPendings)) {
                    setPending(this.useDownMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: ApplicationDownResponseFromProtobufShape(application_pb.DownResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = ApplicationDownAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Application.Down' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useDown(id, setPending) {
        this.useDownSetPendings[id] = setPending;
    }
    unuseDown(id) {
        delete this.useDownSetPendings[id];
    }
    startRevisionStatus(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useRevisionStatusReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Application.RevisionStatus' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.revisionStatusFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useRevisionStatusReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useRevisionStatus(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useRevisionStatus(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useRevisionStatusReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("RevisionStatus", serializedRequest, bearerToken, application_pb.RevisionStatusResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(application_pb.RevisionStatusResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Application.RevisionStatus' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useRevisionStatus(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startRevisionStatus(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseRevisionStatus(id, requestBearerTokenHash) {
        const reader = this.useRevisionStatusReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useRevisionStatusReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    startLogs(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useLogsReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Application.Logs' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.logsFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useLogsReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useLogs(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useLogs(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useLogsReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("Logs", serializedRequest, bearerToken, application_pb.LogsResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(application_pb.LogsResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Application.Logs' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useLogs(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startLogs(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseLogs(id, requestBearerTokenHash) {
        const reader = this.useLogsReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useLogsReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    startActiveRevisions(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useActiveRevisionsReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Application.ActiveRevisions' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.activeRevisionsFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useActiveRevisionsReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useActiveRevisions(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useActiveRevisions(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useActiveRevisionsReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("ActiveRevisions", serializedRequest, bearerToken, application_pb.ActiveRevisionsResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(application_pb.ActiveRevisionsResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Application.ActiveRevisions' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useActiveRevisions(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startActiveRevisions(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseActiveRevisions(id, requestBearerTokenHash) {
        const reader = this.useActiveRevisionsReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useActiveRevisionsReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    startStatus(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useStatusReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Application.Status' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.statusFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useStatusReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useStatus(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useStatus(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useStatusReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("Status", serializedRequest, bearerToken, application_pb.StatusResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(application_pb.StatusResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Application.Status' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useStatus(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startStatus(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseStatus(id, requestBearerTokenHash) {
        const reader = this.useStatusReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useStatusReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    startGet(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useGetReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Application.Get' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.getFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useGetReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useGet(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useGet(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useGetReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("Get", serializedRequest, bearerToken, application_pb.GetResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(application_pb.GetResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Application.Get' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useGet(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startGet(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseGet(id, requestBearerTokenHash) {
        const reader = this.useGetReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useGetReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    startIsAdmin(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useIsAdminReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Application.IsAdmin' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.isAdminFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useIsAdminReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useIsAdmin(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useIsAdmin(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useIsAdminReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("IsAdmin", serializedRequest, bearerToken, application_pb.IsAdminResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(application_pb.IsAdminResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Application.IsAdmin' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useIsAdmin(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startIsAdmin(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseIsAdmin(id, requestBearerTokenHash) {
        const reader = this.useIsAdminReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useIsAdminReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    startListSecrets(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useListSecretsReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Application.ListSecrets' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.listSecretsFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useListSecretsReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useListSecrets(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useListSecrets(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useListSecretsReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("ListSecrets", serializedRequest, bearerToken, application_pb.ListSecretsResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(application_pb.ListSecretsResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Application.ListSecrets' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useListSecrets(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startListSecrets(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseListSecrets(id, requestBearerTokenHash) {
        const reader = this.useListSecretsReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useListSecretsReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    static use(id, stateRef, url) {
        if (!(id in this.instances)) {
            this.instances[id] = new ApplicationInstance(id, stateRef, url);
        }
        else {
            this.instances[id].ref();
        }
        return this.instances[id];
    }
    unuse() {
        if (this.unref() === 0) {
            delete ApplicationInstance.instances[this.id];
        }
    }
}
ApplicationInstance.instances = {};
export function useApplication({ id: providedId } = {}) {
    var _a;
    // Resolve `id` from the frontend-agnostic state-ID map. A `null` map
    // means that resolution is still in flight; an empty map means it
    // resolved with no default ID for us.
    const defaultIds = useDefaultStateIds();
    const isLoading = defaultIds === null;
    // Resolve ID: explicit > URL param (dev) > default-ID map.
    const devId = useMemo(() => {
        // React Native defines `window` but not `window.location`, so both
        // must be checked.
        if (typeof window !== "undefined" &&
            typeof window.location !== "undefined") {
            return new URLSearchParams(window.location.search).get("rbt.cloud.v1alpha1.application.Application.id");
        }
        return null;
    }, []);
    const toolInputId = typeof (defaultIds === null || defaultIds === void 0 ? void 0 : defaultIds["rbt.cloud.v1alpha1.application.Application"]) === "string"
        ? defaultIds["rbt.cloud.v1alpha1.application.Application"]
        : null;
    const resolvedId = (_a = providedId !== null && providedId !== void 0 ? providedId : devId) !== null && _a !== void 0 ? _a : toolInputId;
    // Without a resolved ID we still run every hook below (rules of
    // hooks), binding to the inert empty-ID instance that opens no
    // socket.
    const id = resolvedId !== null && resolvedId !== void 0 ? resolvedId : "";
    // The unresolved no-id case carries an empty `stateRef` rather than
    // computing one. Keyed on the id being unresolved — an explicitly
    // passed empty id still reaches `stateIdToRef`, which rejects it.
    const stateRef = resolvedId == null
        ? ""
        : reboot_api.stateIdToRef("rbt.cloud.v1alpha1.application.Application", id);
    const rebootClient = reboot_react.useRebootClient();
    const url = rebootClient.url;
    const bearerToken = rebootClient.bearerToken;
    const refreshBearerToken = useRefreshBearerToken();
    const [instance, setInstance] = useState(() => {
        return ApplicationInstance.use(id, stateRef, url);
    });
    if (instance.id !== id) {
        setInstance(ApplicationInstance.use(id, stateRef, url));
    }
    useEffect(() => {
        return () => {
            instance.unuse();
        };
    }, [instance]);
    const headers = useMemo(() => {
        const headers = new Headers();
        headers.set("Content-Type", "application/json");
        headers.append("Connection", "keep-alive");
        if (bearerToken !== undefined) {
            headers.append("Authorization", `Bearer ${bearerToken}`);
        }
        return headers;
    }, [bearerToken]);
    function useCreate() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useCreate(id, setPending);
            return () => {
                instance.unuseCreate(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const create = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = ApplicationCreateRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.create(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.create({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        create.pending = pending;
        return create;
    }
    const create = useCreate();
    function usePushInfo(partialRequest = {}, options = { suspense: false }) {
        const newRequest = ApplicationPushInfoRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:PushInfo:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startPushInfo(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && ApplicationPushInfoResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && ApplicationPushInfoAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.usePushInfo(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(ApplicationPushInfoResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = ApplicationPushInfoAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.PushInfo' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unusePushInfo(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function pushInfo(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = ApplicationPushInfoRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/PushInfo`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw ApplicationPushInfoAborted.fromStatus(status);
                        }
                        throw new ApplicationPushInfoAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof ApplicationPushInfoAborted) {
                            return { aborted: e };
                        }
                        const aborted = new ApplicationPushInfoAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.application.ApplicationMethods.PushInfo\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/PushInfo`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: ApplicationPushInfoResponseFromProtobufShape((application_pb.PushInfoResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new ApplicationPushInfoAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new ApplicationPushInfoAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new ApplicationPushInfoAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/PushInfo`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: ApplicationPushInfoResponseFromProtobufShape((application_pb.PushInfoResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = ApplicationPushInfoAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.PushInfo' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new ApplicationPushInfoAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: ApplicationPushInfoResponseFromProtobufShape((application_pb.PushInfoResponse.fromJson(await response.json())))
            };
        }
    }
    function useUp() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useUp(id, setPending);
            return () => {
                instance.unuseUp(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const up = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = ApplicationUpRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.up(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.up({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        up.pending = pending;
        return up;
    }
    const up = useUp();
    function useDown() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useDown(id, setPending);
            return () => {
                instance.unuseDown(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const down = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = ApplicationDownRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.down(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.down({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        down.pending = pending;
        return down;
    }
    const down = useDown();
    function useRevisionStatus(partialRequest = {}, options = { suspense: false }) {
        const newRequest = ApplicationRevisionStatusRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:RevisionStatus:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startRevisionStatus(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && ApplicationRevisionStatusResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && ApplicationRevisionStatusAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useRevisionStatus(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(ApplicationRevisionStatusResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = ApplicationRevisionStatusAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.RevisionStatus' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseRevisionStatus(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function revisionStatus(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = ApplicationRevisionStatusRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/RevisionStatus`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw ApplicationRevisionStatusAborted.fromStatus(status);
                        }
                        throw new ApplicationRevisionStatusAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof ApplicationRevisionStatusAborted) {
                            return { aborted: e };
                        }
                        const aborted = new ApplicationRevisionStatusAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.application.ApplicationMethods.RevisionStatus\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/RevisionStatus`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: ApplicationRevisionStatusResponseFromProtobufShape((application_pb.RevisionStatusResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new ApplicationRevisionStatusAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new ApplicationRevisionStatusAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new ApplicationRevisionStatusAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/RevisionStatus`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: ApplicationRevisionStatusResponseFromProtobufShape((application_pb.RevisionStatusResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = ApplicationRevisionStatusAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.RevisionStatus' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new ApplicationRevisionStatusAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: ApplicationRevisionStatusResponseFromProtobufShape((application_pb.RevisionStatusResponse.fromJson(await response.json())))
            };
        }
    }
    function useActiveRevisions(partialRequest = {}, options = { suspense: false }) {
        const newRequest = ApplicationActiveRevisionsRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:ActiveRevisions:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startActiveRevisions(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && ApplicationActiveRevisionsResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && ApplicationActiveRevisionsAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useActiveRevisions(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(ApplicationActiveRevisionsResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = ApplicationActiveRevisionsAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.ActiveRevisions' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseActiveRevisions(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function activeRevisions(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = ApplicationActiveRevisionsRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/ActiveRevisions`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw ApplicationActiveRevisionsAborted.fromStatus(status);
                        }
                        throw new ApplicationActiveRevisionsAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof ApplicationActiveRevisionsAborted) {
                            return { aborted: e };
                        }
                        const aborted = new ApplicationActiveRevisionsAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.application.ApplicationMethods.ActiveRevisions\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/ActiveRevisions`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: ApplicationActiveRevisionsResponseFromProtobufShape((application_pb.ActiveRevisionsResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new ApplicationActiveRevisionsAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new ApplicationActiveRevisionsAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new ApplicationActiveRevisionsAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/ActiveRevisions`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: ApplicationActiveRevisionsResponseFromProtobufShape((application_pb.ActiveRevisionsResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = ApplicationActiveRevisionsAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.ActiveRevisions' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new ApplicationActiveRevisionsAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: ApplicationActiveRevisionsResponseFromProtobufShape((application_pb.ActiveRevisionsResponse.fromJson(await response.json())))
            };
        }
    }
    function useStatus(partialRequest = {}, options = { suspense: false }) {
        const newRequest = ApplicationStatusRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:Status:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startStatus(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && ApplicationStatusResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && ApplicationStatusAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useStatus(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(ApplicationStatusResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = ApplicationStatusAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.Status' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseStatus(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function status(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = ApplicationStatusRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/Status`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw ApplicationStatusAborted.fromStatus(status);
                        }
                        throw new ApplicationStatusAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof ApplicationStatusAborted) {
                            return { aborted: e };
                        }
                        const aborted = new ApplicationStatusAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.application.ApplicationMethods.Status\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/Status`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: ApplicationStatusResponseFromProtobufShape((application_pb.StatusResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new ApplicationStatusAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new ApplicationStatusAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new ApplicationStatusAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/Status`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: ApplicationStatusResponseFromProtobufShape((application_pb.StatusResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = ApplicationStatusAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.Status' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new ApplicationStatusAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: ApplicationStatusResponseFromProtobufShape((application_pb.StatusResponse.fromJson(await response.json())))
            };
        }
    }
    function useGet(partialRequest = {}, options = { suspense: false }) {
        const newRequest = ApplicationGetRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:Get:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startGet(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && ApplicationGetResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && ApplicationGetAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useGet(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(ApplicationGetResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = ApplicationGetAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.Get' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseGet(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function get(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = ApplicationGetRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/Get`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw ApplicationGetAborted.fromStatus(status);
                        }
                        throw new ApplicationGetAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof ApplicationGetAborted) {
                            return { aborted: e };
                        }
                        const aborted = new ApplicationGetAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.application.ApplicationMethods.Get\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/Get`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: ApplicationGetResponseFromProtobufShape((application_pb.GetResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new ApplicationGetAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new ApplicationGetAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new ApplicationGetAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/Get`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: ApplicationGetResponseFromProtobufShape((application_pb.GetResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = ApplicationGetAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.Get' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new ApplicationGetAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: ApplicationGetResponseFromProtobufShape((application_pb.GetResponse.fromJson(await response.json())))
            };
        }
    }
    function useIsAdmin(partialRequest = {}, options = { suspense: false }) {
        const newRequest = ApplicationIsAdminRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:IsAdmin:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startIsAdmin(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && ApplicationIsAdminResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && ApplicationIsAdminAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useIsAdmin(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(ApplicationIsAdminResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = ApplicationIsAdminAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.IsAdmin' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseIsAdmin(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function isAdmin(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = ApplicationIsAdminRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/IsAdmin`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw ApplicationIsAdminAborted.fromStatus(status);
                        }
                        throw new ApplicationIsAdminAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof ApplicationIsAdminAborted) {
                            return { aborted: e };
                        }
                        const aborted = new ApplicationIsAdminAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.application.ApplicationMethods.IsAdmin\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/IsAdmin`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: ApplicationIsAdminResponseFromProtobufShape((application_pb.IsAdminResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new ApplicationIsAdminAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new ApplicationIsAdminAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new ApplicationIsAdminAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/IsAdmin`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: ApplicationIsAdminResponseFromProtobufShape((application_pb.IsAdminResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = ApplicationIsAdminAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.IsAdmin' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new ApplicationIsAdminAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: ApplicationIsAdminResponseFromProtobufShape((application_pb.IsAdminResponse.fromJson(await response.json())))
            };
        }
    }
    function useListSecrets(partialRequest = {}, options = { suspense: false }) {
        const newRequest = ApplicationListSecretsRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:ListSecrets:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startListSecrets(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && ApplicationListSecretsResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && ApplicationListSecretsAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useListSecrets(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(ApplicationListSecretsResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = ApplicationListSecretsAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.ListSecrets' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseListSecrets(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function listSecrets(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = ApplicationListSecretsRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/ListSecrets`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw ApplicationListSecretsAborted.fromStatus(status);
                        }
                        throw new ApplicationListSecretsAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof ApplicationListSecretsAborted) {
                            return { aborted: e };
                        }
                        const aborted = new ApplicationListSecretsAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.application.ApplicationMethods.ListSecrets\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/ListSecrets`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: ApplicationListSecretsResponseFromProtobufShape((application_pb.ListSecretsResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new ApplicationListSecretsAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new ApplicationListSecretsAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new ApplicationListSecretsAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.application.ApplicationMethods/ListSecrets`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: ApplicationListSecretsResponseFromProtobufShape((application_pb.ListSecretsResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = ApplicationListSecretsAborted.fromStatus(status);
                console.warn(`[Reboot] 'Application.ListSecrets' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new ApplicationListSecretsAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: ApplicationListSecretsResponseFromProtobufShape((application_pb.ListSecretsResponse.fromJson(await response.json())))
            };
        }
    }
    // Don't re-render if `id` hasn't changed.
    const api = useMemo(() => ({
        state_id: id,
        mutators: {
            create,
            up,
            down,
        },
        idempotently: ({ key }) => {
            return {
                create: (partialRequest, options) => create(partialRequest, { ...options, key }),
                up: (partialRequest, options) => up(partialRequest, { ...options, key }),
                down: (partialRequest, options) => down(partialRequest, { ...options, key }),
            };
        },
        create,
        pushInfo,
        usePushInfo,
        up,
        down,
        revisionStatus,
        useRevisionStatus,
        activeRevisions,
        useActiveRevisions,
        status,
        useStatus,
        get,
        useGet,
        isAdmin,
        useIsAdmin,
        listSecrets,
        useListSecrets,
    }), [id, instance, bearerToken, refreshBearerToken]);
    // An explicit `id` caller gets the handle directly; a no-id caller
    // gets the `{ application, isLoading }`
    // shape, where the handle is `undefined` until a default ID
    // resolves.
    if (providedId !== undefined) {
        return api;
    }
    return {
        application: resolvedId ? api : undefined,
        isLoading,
    };
}
;
export class Application {
}
Application.State = ApplicationProto;
